import parsePhoneNumber from 'libphonenumber-js'
import { SBPhoneNumber } from '../modules/sb-antd-phone-input/SBPhoneInput'

export const phoneMetadataToString = (
  phone: SBPhoneNumber | string | null | undefined
): string => {
  if (!phone) return ''
  if (typeof phone === 'string') return phone
  return (
    '+' +
    (phone.countryCode ?? '') +
    (phone.areaCode ?? '') +
    (phone.phoneNumber ?? '')
  )
}

export const formatPhoneNumberToE164FromPhoneInput = (
  phoneData: SBPhoneNumber
): string => {
  const phoneNumber = parsePhoneNumber(phoneData.typed ?? '')
  return phoneNumber!.format('E.164')
}
